export default "__VITE_ASSET__395c53df__"